<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1 class="text-center">Belohnungsanfragen</h1>
      </v-col>
    </v-row>
    <v-toolbar flat>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-toolbar>

    <!-- Desktop: Data Table -->
    <v-data-table
      v-if="!$vuetify.breakpoint.smAndDown"
      :search="search"
      :headers="headers"
      :items="reward_requests"
      sort-by="calories"
      class="elevation-1"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top color="success">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="mr-2" @click="acceptRewardRequest(item)" v-bind="attrs" v-on="on">
              mdi-check
            </v-icon>
          </template>
          <span>Annehmen!</span>
        </v-tooltip>
        <v-tooltip top color="error">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="mr-2" @click="cancelRewardRequest(item)" v-bind="attrs" v-on="on">
              mdi-close
            </v-icon>
          </template>
          <span>Ablehnen!</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.lr_reedem_tstmp`]="{ item }">
        <div v-if="item.lr_reedem_tstmp">
          {{ new Date(item.lr_reedem_tstmp * 1000).toLocaleString('de-De') }}
        </div>
        <i v-else>-</i>
      </template>
    </v-data-table>

    <!-- Mobile: Card List -->
    <template v-else>
      <v-card
        v-for="item in mobileItems"
        :key="item.lr_id"
        class="mb-3"
        outlined
      >
        <v-card-title class="py-2">
          <span class="subtitle-1 font-weight-bold">{{ item.lr_title }}</span>
        </v-card-title>
        <v-card-subtitle class="pb-0">
          <v-chip x-small class="mr-1">{{ item.username }}</v-chip>
          <v-chip x-small color="info" class="mr-1">{{ item.lr_cost }} Punkte</v-chip>
        </v-card-subtitle>
        <v-card-text class="pt-2">
          <div v-if="item.lr_userinput" class="body-2">
            <strong>Userinput:</strong> {{ item.lr_userinput }}
          </div>
          <div class="caption grey--text mt-1">
            <span v-if="item.lr_reedem_tstmp">
              {{ new Date(item.lr_reedem_tstmp * 1000).toLocaleString('de-De') }}
            </span>
            <i v-else>-</i>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn icon color="error" @click="cancelRewardRequest(item)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn icon color="success" @click="acceptRewardRequest(item)">
            <v-icon>mdi-check</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-alert v-if="mobileItems.length === 0" type="info" class="mt-2">
        Keine Belohnungsanfragen gefunden.
      </v-alert>
    </template>

    <v-row class="mt-2">
      <v-col cols="6">
        <v-btn @click="acceptallRewardRequest()" class="success">Alle akzeptieren</v-btn>
      </v-col>
      <v-col cols="6" class="text-right">
        <v-btn @click="cancelallRewardRequest()" class="error ml-auto">Alle ablehnen</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import BackendService from '@/services/BackendService';

export default {
  name: 'LoyaltyRewardList',
  data: () => ({
    reward_requests: [],
    search: null,
    intervalId: null,
    headers: [
      { text: 'Belohnung', value: 'lr_title', align: 'center' },
      { text: 'User', value: 'username', align: 'center' },
      { text: 'Userinput', value: 'lr_userinput', align: 'center' },
      { text: 'Kosten', value: 'lr_cost', align: 'center' },
      { text: 'Angefragt am', value: 'lr_reedem_tstmp', align: 'center' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    editedIndex: -1,
    editedItem: {
    },
    defaultItem: {
    },
  }),
  computed: {
    mobileItems() {
      if (!this.search) return this.reward_requests;
      const s = this.search.toLowerCase();
      return this.reward_requests.filter((r) => (r.lr_title && r.lr_title.toLowerCase().includes(s))
        || (r.username && r.username.toLowerCase().includes(s))
        || (r.lr_userinput && r.lr_userinput.toLowerCase().includes(s)));
    },
  },
  mounted() {
    this.intervalId = window.setInterval(this.updateTimer, 10000);
    BackendService.loadRewardRequests().then((data) => {
      // console.log(data.data);
      this.reward_requests = data.data;
    });
  },
  destroyed() {
    clearInterval(this.intervalId);
  },
  methods: {
    updateTimer() {
      BackendService.loadRewardRequests().then((data) => {
        // console.log(data.data);
        this.reward_requests = data.data;
      });
    },
    acceptRewardRequest(item) {
      // console.log(item);
      const updates = {
        lr_decision_mod: this.$store.state.username,
        lr_decision_mod_id: this.$store.state.userid,
        lr_decision_tstmp: Date.now() / 1000,
      };

      // Reaktiv das Item aktualisieren
      Object.keys(updates).forEach((key) => {
        this.$set(item, key, updates[key]);
      });
      BackendService.acceptRewardRequests(item).then((data) => {
        // console.log(data.data);
        this.reward_requests = data.data;
      });
    },
    cancelRewardRequest(item) {
      const updates = {
        lr_decision_mod: this.$store.state.username,
        lr_decision_mod_id: this.$store.state.userid,
        lr_decision_tstmp: Date.now() / 1000,
      };

      // Reaktiv das Item aktualisieren
      Object.keys(updates).forEach((key) => {
        this.$set(item, key, updates[key]);
      });
      // console.log(item);
      BackendService.cancelRewardRequests(item).then((data) => {
        // console.log(data.data);
        this.reward_requests = data.data;
      });
    },
    acceptallRewardRequest() {
      const decision = {
        lr_decision_mod: this.$store.state.username,
        lr_decision_mod_id: this.$store.state.userid,
        lr_decision_tstmp: Date.now() / 1000,
      };
      // console.log(this.$store.state);
      BackendService.acceptallRewardRequests(decision).then((data) => {
        // console.log(data.data);
        this.reward_requests = data.data;
      });
    },
    cancelallRewardRequest() {
      const decision = {
        lr_decision_mod: this.$store.state.username,
        lr_decision_mod_id: this.$store.state.userid,
        lr_decision_tstmp: Date.now() / 1000,
      };
      BackendService.cancelallRewardRequests(decision).then((data) => {
        // console.log(data.data);
        this.reward_requests = data.data;
      });
    },
  },
};
</script>
<style>
.chipGroup label {
  font-size: 12px;
}
</style>
